import React from "react";
import { SkeletonCard } from "../../../components/ui";

/**
 * The three cards of the overview, at the heights they stand at: the dietitian
 * and their figures, their practice, and the tags they work under.
 *
 * Heights rather than contents — what is inside each card is the card's own
 * business once it lands.
 */
const CARDS = ["h-[131px]", "h-[113px]", "h-[104px]"];

/**
 * The overview while the profile is read.
 *
 * Three cards in the three places the real ones take, so the screen is already
 * drawn when the answer lands and nothing jumps as it fills in. One
 * `role="status"` line carries the whole thing for a screen reader — the blocks
 * themselves are hidden, since the shape of an answer read out is worse than
 * silence.
 */
const ProfileOverviewSkeleton: React.FC = () => (
  <div className="flex flex-col gap-4">
    <span role="status" className="sr-only">
      Loading your profile
    </span>

    {CARDS.map((height) => (
      <SkeletonCard key={height} className={height} />
    ))}
  </div>
);

export default ProfileOverviewSkeleton;
